export const convertObjectValueToNumber = <T extends Record<string, string | number>>(o: T) =>
  Object.keys(o).reduce((a, b: keyof T) => {
    const returnObject = { ...a };
    returnObject[b] = Number(o[b]);
    return returnObject;
  }, {} as Record<keyof T, number>);
